// Centralized site constants
export const COMPANY = {
  name: "Five Star Reinigung",
  tagline: "Sauberkeit auf höchstem Niveau",
  ceo: "Wallat Ramo",
  address: {
    street: "Maudacher Str. 219",
    zip: "67065",
    city: "Ludwigshafen am Rhein",
  },
  phone: "+49 176 32809714",
  phoneHref: "tel:+4917632809714",
  email: "ramowallat@gmail.com",
  region: "Baden-Württemberg",
  coverage: "Deutschlandweit · Schwerpunkt Baden-Württemberg",
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_gebaeude-rein/artifacts/2f9ymchd_logo%20five%20star.jpeg",
  ceoPortrait: "https://customer-assets.emergentagent.com/job_6f6de580-8fee-4994-a207-aa513053a007/artifacts/8ol4b4zt_ramo%20PB.jpeg",
  hero: "https://images.pexels.com/photos/1755288/pexels-photo-1755288.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  about: "https://images.unsplash.com/photo-1612283157924-f0e11f121c3f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const SERVICES = [
  {
    slug: "gebaeudereinigung",
    title: "Gebäudereinigung",
    short: "Büros, Praxen, Treppenhäuser, Glas- und Unterhaltsreinigung.",
    image: "https://images.unsplash.com/photo-1706074793638-da28b90ea8ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    bullets: [
      "Büro- und Verwaltungsreinigung",
      "Treppenhaus- und Unterhaltsreinigung",
      "Glas- und Fensterreinigung",
      "Praxen, Kanzleien & Empfangsbereiche",
    ],
  },
  {
    slug: "industriereinigung",
    title: "Industriereinigung",
    short: "Hallen, Produktionsstätten und Maschinenumgebungen — gründlich, sicher, zertifiziert.",
    image: "https://images.unsplash.com/photo-1720036236697-018370867320?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    bullets: [
      "Produktionshallen & Lagerflächen",
      "Maschinen- und Anlagenreinigung",
      "Bodenreinigung & Beschichtungen",
      "Sicherheits- und Hygienestandards",
    ],
  },
  {
    slug: "bauendreinigung",
    title: "Bauendreinigung",
    short: "Übergabefertige Reinigung nach Bauarbeiten und Renovierungen.",
    image: "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    bullets: [
      "Grob-, Fein- und Endreinigung",
      "Entfernung von Bauschutt-Resten",
      "Fenster, Rahmen, Profile",
      "Übergabe-Reinigung für Bauträger",
    ],
  },
];

export const FAQ = [
  {
    q: "In welcher Region sind Sie tätig?",
    a: "Wir sind deutschlandweit verfügbar. Unser Schwerpunkt liegt jedoch in Baden-Württemberg — von dort aus betreuen wir den überwiegenden Teil unserer Kunden.",
  },
  {
    q: "Welche Leistungen bieten Sie an?",
    a: "Gebäudereinigung, Industriereinigung und Bauendreinigung. Für jedes Objekt erstellen wir ein individuelles Konzept und ein verbindliches Angebot.",
  },
  {
    q: "Wie schnell erhalte ich ein Angebot?",
    a: "In der Regel innerhalb von 24 Stunden nach Ihrer Anfrage. Bei größeren Objekten vereinbaren wir gerne einen kostenfreien Vor-Ort-Termin.",
  },
  {
    q: "Sind Sie versichert und zertifiziert?",
    a: "Ja. Wir verfügen über die branchenüblichen Versicherungen und arbeiten ausschließlich mit sorgfältig geprüften Reinigungsverfahren.",
  },
  {
    q: "Gibt es einen Mindestauftragswert?",
    a: "Wir betreuen sowohl kleine Praxisflächen als auch großflächige Industrieobjekte — sprechen Sie uns an, wir finden eine faire Lösung.",
  },
  {
    q: "Wer ist mein Ansprechpartner?",
    a: "Herr Wallat Ramo, Geschäftsführer von Five Star Reinigung, steht Ihnen persönlich für alle Anfragen zur Verfügung.",
  },
];
